import Services from "./Services.component"

export default Services